import { Flex, Stack, Text, useMantineTheme } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import classes from './AfaAvisosTerminisCard.module.css';

export interface AfaAvisosTerminisCardProps {
  title: string;
  dataLimit: string | Date;
  onClick?: () => void;
  estat: string;
}

const AfaAvisosTerminisCard = ({ 
  title, 
  dataLimit, 
  onClick,
  estat
}: AfaAvisosTerminisCardProps) => {
  const theme = useMantineTheme();
  
  // Convertir dataLimit a Date si es string
  const getDateObject = (date: string | Date): Date => {
    if (date instanceof Date) return date;
    
    // Asumir formato DD/MM/YYYY
    const parts = date.split('/').map(Number);
    const day = parts[0] || 1;
    const month = parts[1] || 1;
    const year = parts[2] || new Date().getFullYear();
    
    return new Date(year, month - 1, day);
  };

  // Calcular nivel de urgencia según días restantes
  const getUrgencyLevel = (): 'urgent' | 'warning' | 'normal' => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const limitDate = getDateObject(dataLimit);
    limitDate.setHours(0, 0, 0, 0);
    
    const diffTime = limitDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays <= 0) return 'urgent';      // Rojo: ≤ 5 días
    if (diffDays <= 10) return 'warning';    // Amarillo: 6-10 días
    return 'normal';                         // Negro: > 10 días
  };

  // Formatear fecha para visualización
  const formatDate = (): string => {
    if (typeof dataLimit === 'string') return dataLimit;
    
    const date = dataLimit;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  };

  const urgencyLevel = getUrgencyLevel();
  
  // Determinar color según nivel de urgencia
  const getDateColor = () => {
    switch (urgencyLevel) {
      case 'urgent':
        return 'red.5';      // Rojo: ≤ 5 días
      case 'warning':
        return 'yellow.5';   // Amarillo: 6-10 días
      case 'normal':
      default:
        return 'neutral.9';  // Negro: > 10 días
    }
  };

  return (
    <div 
      className={classes.card} 
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <Flex justify="space-between" align="center" gap="md">
        {/* Lado izquierdo: Título y fecha */}
        <Stack gap={4} style={{ flex: 1 }}>
          <Text size="md" fw={600} c="brand.5">
            {title}
          </Text>
          <Text size="sm">
            {/* <Text size="sm" c={theme.other.black}>{estat}</Text>
            <Text size="sm" c={theme.other.black}>{dataLimit.toString()}</Text> */}
            <Text component="span" c={theme.other.black}>Data límit: </Text>
            <Text component="span" c={getDateColor()}>{formatDate()}</Text>
          </Text>
        </Stack>

        {/* Lado derecho: Icono chevron */}
        <IconChevronRight 
          size={20} 
          color={theme.other.black} 
          style={{ flexShrink: 0 }}
        />
      </Flex>
    </div>
  );
};

export default AfaAvisosTerminisCard;
